import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MultiSelect from './multiselect'
import {
  setSelectedSitesFilterControlPanel,
  setSelectedAssetsFilterControlPanel,
  setAssetsControlPanel,
  setSearchAssetsBySitesFlag,
  setSearchSitesByAssetsFlag,
} from '../../../../store/actions/controlPanel'
import { getAssetsBySitesControlPanel } from '../../../../api/controlPanel'
import { makeQueryApiAssetsSites } from '../../../../utils/productionPanel'
import { setHandleAlert } from '../../../../store/actions/common'

const SitesFilter = ({ options, placeholder, label }) => {
  const dispatch = useDispatch()
  const [selectedOptions, setSelectedOptions] = useState([])
  const [stateSelectedSitesList, setStateSelectedSitesList] = useState('')
  const selectedSitesList = useSelector(
    (state) => state.controlPanel.selectedSitesFilter
  )
  const userData = useSelector(({ multitenantUser }) => ({
    accessToken: multitenantUser.accessToken,
    tenantId: multitenantUser.tenants?.find((t) => t.selected)?.id || 0,
  }))
  const sitesByAssetsFlag = useSelector(
    (state) => state.controlPanel.sitesByAssetsFlag
  )
  const getOptionLabel = (option) => option.name

  useEffect(() => {
    setSelectedOptions(selectedSitesList)
    let sitesQuery = makeQueryApiAssetsSites(selectedSitesList, 'sitesIds')
    setStateSelectedSitesList(sitesQuery)
  }, [selectedSitesList])

  useEffect(() => {
    if (!sitesByAssetsFlag) {
      getAssetsBySitesControlPanelFunction(stateSelectedSitesList)
      if (stateSelectedSitesList.length === 0) {
        dispatch(setSearchAssetsBySitesFlag(false))
      }
    }
  }, [stateSelectedSitesList])

  const handleToggleOption = (selectedOptns) => {
    setSelectedOptions(selectedOptns)
    dispatch(setSearchAssetsBySitesFlag(true))
    dispatch(setSelectedSitesFilterControlPanel(selectedOptns))
  }

  const handleClearOptions = () => {
    setSelectedOptions([])
    dispatch(setSelectedSitesFilterControlPanel([]))
    dispatch(setSelectedAssetsFilterControlPanel([]))
    dispatch(setSearchAssetsBySitesFlag(false))
    dispatch(setSearchSitesByAssetsFlag(false))
  }

  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      setSelectedOptions(options)
      dispatch(setSearchAssetsBySitesFlag(true))
      dispatch(setSelectedSitesFilterControlPanel(options))
    }

    if (!isSelected) {
      handleClearOptions()
    }
  }

  const getAssetsBySitesControlPanelFunction = (sitesQuery) => {
    if (userData?.accessToken) {
      getAssetsBySitesControlPanel(
        userData.accessToken,
        userData.tenantId,
        sitesQuery
      )
        .then((response) => {
          dispatch(setAssetsControlPanel(response.data))
          dispatch(setSelectedAssetsFilterControlPanel(response.data))
        })
        .catch((error) => {
          console.error(error)
          showAlertMessage('Something wrong happened')
        })
    }
  }

  const showAlertMessage = (message, status, severity) => {
    dispatch(
      setHandleAlert({
        message,
        status,
        severity,
      })
    )
  }

  return (
    <MultiSelect
      items={options}
      getOptionLabel={getOptionLabel}
      selectedValues={selectedOptions}
      label={label}
      placeholder={placeholder}
      selectAllLabel="Select all"
      onToggleOption={handleToggleOption}
      onClearOptions={handleClearOptions}
      onSelectAll={handleSelectAll}
      id={`sitesFilter`}
    />
  )
}

export default SitesFilter
